import React, { createContext, useState, useContext } from 'react';

const PaymentIntentContext = createContext();

export const usePaymentIntent = () =>  useContext(PaymentIntentContext);

export const PaymentIntentProvider = ({ children }) => {
    const [ clientSecret, setClientSecret ] = useState('');
    const [ paymentRequestDetails, setPaymentRequestDetails ] = useState(null);
    const [ rating, setRating ] = useState(null);
    const [ feedbackComplete, setFeedbackComplete ] = useState(false);

    const value = {
        clientSecret,
        setClientSecret,
        paymentRequestDetails,
        setPaymentRequestDetails,
        rating,
        setRating,
        feedbackComplete,
        setFeedbackComplete
    };

    return <PaymentIntentContext.Provider value={value}>{children}</PaymentIntentContext.Provider>
};
